import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { Produit, ProduitAPI } from '../models/produit.model';

@Injectable({
  providedIn: 'root'
})
export class ProduitService {
  constructor(private api: ApiService) {}

  getAllProduits(): Observable<Produit[]> {
    return this.api.get<ProduitAPI[]>('/articles').pipe(
      map(produits => produits.map(p => this.mapProduit(p)))
    );
  }

  getProduitById(id: number): Observable<Produit> {
    return this.api.get<ProduitAPI>(`/articles/${id}`).pipe(
      map(p => this.mapProduit(p))
    );
  }

  getCatalogue(): Observable<any> {
    return this.api.get<any>('/articles/catalogue');
  }

  private mapProduit(apiProduit: ProduitAPI): Produit {
    return {
      id: apiProduit.PLU, // Utiliser PLU comme ID
      plu: apiProduit.PLU,
      titre: apiProduit.titre,
      titre_commercial: apiProduit.titre_commercial,
      ingredient: apiProduit.ingredient,
      allergene: apiProduit.allergene,
      valeurNutritionnelle: apiProduit.valeurNutritionnelle,
      familleId: apiProduit.familleId,
      is_activated: true, // Par défaut actif car le backend ne retourne pas ce champ
      image: apiProduit.img || undefined
    };
  }
}
